export default {
  content: {
    title: "Booking",
    searchPlaceholder: "Search candidate name, job position",
    searchPlaceholder2: "Search candidate name",
    searchPlaceholder3: "Search Appointment booker, Subject",
    searchPlaceholder4: "Search Appointment booker",
    listOfBooking: "List of booking",
    noDataFound: "No data found",
    candidatesTracking: "Candidates Tracking",
    bookerTracking: "Bookers Tracking",

    allInterviewDate: "All Interview Dates",
    selectInterviewStatus: "Select Interview Status",
    showOnlyRegisteredTimes: "Show Only Registered Times",
    downloadBooking: "Download Booking",
  },

  tableHead: {
    interviewDate: "Interview Date",
    interviewTime: "Time",
    candidateName: "Candidate Name",
    appointmentBooker: "Appointment booker",
    jobPosition: "Position",
    status: "Status",

    category: "Category",
    applyDate: "Apply Date",
  },

  preview: {
    detail: "Detail",
    detailFund: "Fund Detail",
    edit: "Edit"
  },
  title: {
    createDetail: "Creation Details",
    createDetailFund: "Fund Creation Details",
    business: "Business",
    subject: "Subject",
    subjectFund: "Fund Subject",
    qualification: "Qualification Details",
    qualificationFund: "Fund Details",
    jobDescription: "Job Position Details",
    jobDescriptionCondition: "Condition",
  },

  rule: {
    selectBusiness: "Please select an Business",
    enterSubject: "Enter subject",
    enterSubjectFund: "Enter fund subject",
    subjectRequired: "Please enter a subject",
    subjectRequiredFund: "Please enter a fund subject",
    noLeadingSpace: "Leading spaces are not allowed",
    singleSpaceOnly: "Only one space is allowed between words",
    maxLength200: "Maximum 200 characters allowed",

    changeStatusTo: "Change status to",
    comment: "Comment",
    enterComment: "Enter comment",
    recommendRequired: "Please recommend a related organization",
    optional: "Optional",
  },

  btn: {
    saveDraft: "Save Draft",
    post: "Post",
    postFund: "Post Fund",
  },
};
